import {PersonOutlinedChip} from "../../../../../components/buttons/IconButtons";
import React from "react";
import CustomTooltip from "../../../../../components/CustomTooltip";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import CustomCard from "../../../../../components/CustomCard";
import NotInformation from "../../../../../components/NotInformation";
import {useTranslation} from "react-i18next";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 02 de diciembre de 2025
 */

const RenderExpandedRow = ({row, onCheckIn }) => {
    const {t} = useTranslation();
    return (
        <>
            <div className={"row minw-290px"}>
                {row?.employees?.length > 0 ?
                    <>
                        {row?.employees?.map(item => {
                            return (
                                <CustomCard  key={item.id} classes={'my-1'}
                                             classCard={`card-border-8px p-16px`}
                                             classContent={`p-0 background-general-00`}
                                >
                                    <div className={"p-0 m-0 row col-12 justify-content-between"}>
                                        <div className={"col-sm-12 col-md-1 px-0"}>
                                            <div className={`background-primary-100 d-flex justify-content-center align-items-center p-1 border-radius-4px`}>
                                                <div> <PersonOutlinedChip className={"w-h-24px"}/></div>
                                            </div>
                                        </div>
                                        <div className={"col-sm-12 col-md-11"}>
                                            <div className={"d-flex flex-column justify-content-start gap-1 justify-content-center"}>
                                                <CustomTooltip
                                                    text={item?.name}
                                                    classes={"text-capitalize font-color-general-950 ibl-font-w-600 fs-16px text-ellipsis-1-row"}
                                                    showIfTruncated={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <ButtonAction
                                        id={`btn_rer_check_in`}
                                        name={'check_in'}
                                        className="btn-outlined-secondary-600-00 w-100 mt-3"
                                        splitName={false}
                                        onClick={() => onCheckIn(item)}
                                    />
                                </CustomCard>
                            );
                        })
                        }
                    </>
                    :
                    <NotInformation card={true} text={t('you_dont_have_any_records')} />
                }
            </div>
        </>

    );

};

export default RenderExpandedRow
